<script lang="ts">
    import { onMount } from 'svelte';

    let isDarkMode: boolean = false
    onMount(() => {
        isDarkMode = !!document.querySelector('.darkWrapper');
    });
    $: fillcolour = isDarkMode ? '#53BFED' : "#EA215B"
</script>

<style>
    svg {
        top: -2px;
        position: relative;
        padding-right: 0.8em;
        opacity: 80%;
        transition: all 150ms ease-out;
    }

    svg:hover {
        opacity: 100%;
        transform: scale(1.05);
    }
</style>

<a href="/">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="30" height="30"><g id="Layer_1-2" data-name="Layer 1">
        <path d="M61,1.16A50.1,50.1,0,0,1,92.1,23a2.24,2.24,0,0,1-.77,3.13L74,36.11a2.21,2.21,0,0,1-2.92-.65A25.66,25.66,0,0,0,56.43,25.17a2.21,2.21,0,0,1-1.61-2.54L58.29,3A2.23,2.23,0,0,1,61,1.16Z" fill={fillcolour} />
        <path d="M13.23,16.09A50,50,0,0,1,47.68,0,2.23,2.23,0,0,1,50,2.23v20a2.21,2.21,0,0,1-2,2.22A25.63,25.63,0,0,0,31.73,32a2.22,2.22,0,0,1-3,.13L13.44,19.29A2.21,2.21,0,0,1,13.23,16.09Z" fill={fillcolour}/>
        <path d="M2.27,64.92A50.14,50.14,0,0,1,5.58,27a2.23,2.23,0,0,1,3.09-.89L26,36.11a2.2,2.2,0,0,1,.9,2.85A25.76,25.76,0,0,0,25.3,56.85a2.2,2.2,0,0,1-1.39,2.65L5.16,66.34A2.23,2.23,0,0,1,2.27,64.92Z" fill={fillcolour}/>
        <path d="M39,98.84A50.1,50.1,0,0,1,7.9,77a2.24,2.24,0,0,1,.77-3.13L26,63.89a2.21,2.21,0,0,1,2.92.65A25.66,25.66,0,0,0,43.57,74.83a2.21,2.21,0,0,1,1.61,2.54L41.71,97A2.23,2.23,0,0,1,39,98.84Z" fill={fillcolour} />
        <path d="M86.77,83.91A50,50,0,0,1,52.32,100,2.23,2.23,0,0,1,50,97.77v-20a2.21,2.21,0,0,1,2-2.22A25.63,25.63,0,0,0,68.27,68a2.22,2.22,0,0,1,3-.13L86.56,80.71A2.21,2.21,0,0,1,86.77,83.91Z" fill={fillcolour}/>
        <path d="M97.73,35.08A50.14,50.14,0,0,1,94.42,73a2.23,2.23,0,0,1-3.09.89L74,63.89a2.2,2.2,0,0,1-.9-2.85A25.76,25.76,0,0,0,74.7,43.15a2.2,2.2,0,0,1,1.39-2.65l18.75-6.84A2.23,2.23,0,0,1,97.73,35.08Z" fill={fillcolour}/>
    </g></svg>
</a>